import { GridRowParams } from '@mui/x-data-grid/models/params/gridRowParams';
import { GridActionsCellItem } from '@mui/x-data-grid/components';
import { GridColDef,  } from '@mui/x-data-grid/models/colDef/gridColDef';
import { Delete } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { Host } from '@/api/bol';

interface HostColumnsProps {
  onDelete: (host: Host) => void;
  canDelete?: boolean;
  deleteTooltip?: string;
  canEdit?: boolean;
}

export const createHostColumns = ({ onDelete, canDelete = true, deleteTooltip = '' }: HostColumnsProps): GridColDef[] => [
  {
    field: 'name',
    headerName: 'Host Name',
    flex: 1,
    minWidth: 150,
    valueGetter: (value: string | undefined, row: Host) => {
      return row.name || '-';
    },
  },
  {
    field: 'uri',
    headerName: 'URI',
    flex: 2,
    minWidth: 250,
    valueGetter: (value: string | undefined, row: Host) => {
      return row.uri || '-';
    },
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Actions',
    width: 80,
    hideable: false, // Always visible
    getActions: (params: GridRowParams<Host>) => [
      <Tooltip title={!canDelete ? deleteTooltip : ''} key="delete-tooltip">
        <span>
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={() => onDelete(params.row)}
            disabled={!canDelete}
            color="error"
          />
        </span>
      </Tooltip>,
    ],
  },
];